export const FETCH_CLIENTS_INVOICES_REQUEST = 'FETCH_CLIENTS_INVOICES_REQUEST';
export const FETCH_CLIENTS_INVOICES_SUCCESS = 'FETCH_CLIENTS_INVOICES_SUCCESS';
export const FETCH_CLIENTS_INVOICES_FAILURE = 'FETCH_CLIENTS_INVOICES_FAILURE';

export const FETCH_ALL_CLIENTS_INVOICES_REQUEST = 'FETCH_ALL_CLIENTS_INVOICES_REQUEST';
export const FETCH_ALL_CLIENTS_INVOICES_SUCCESS = 'FETCH_ALL_CLIENTS_INVOICES_SUCCESS';
export const FETCH_ALL_CLIENTS_INVOICES_FAILURE = 'FETCH_ALL_CLIENTS_INVOICES_FAILURE';

export const FETCH_PARTNERS_INVOICES_REQUEST = 'FETCH_PARTNERS_INVOICES_REQUEST';
export const FETCH_PARTNERS_INVOICES_SUCCESS = 'FETCH_PARTNERS_INVOICES_SUCCESS';
export const FETCH_PARTNERS_INVOICES_FAILURE = 'FETCH_PARTNERS_INVOICES_FAILURE';

export const FETCH_ALL_PARTNERS_INVOICES_REQUEST = 'FETCH_ALL_PARTNERS_INVOICES_REQUEST';
export const FETCH_ALL_PARTNERS_INVOICES_SUCCESS = 'FETCH_ALL_PARTNERS_INVOICES_SUCCESS';
export const FETCH_ALL_PARTNERS_INVOICES_FAILURE = 'FETCH_ALL_PARTNERS_INVOICES_FAILURE';

export const FETCH_PARTNER_INVOICE_LINES_REQUEST = 'FETCH_PARTNER_INVOICE_LINES_REQUEST';
export const FETCH_PARTNER_INVOICE_LINES_SUCCESS = 'FETCH_PARTNER_INVOICE_LINES_SUCCESS';
export const FETCH_PARTNER_INVOICE_LINES_FAILURE = 'FETCH_PARTNER_INVOICE_LINES_FAILURE';

export const MARKPAID_PARTNER_INVOICE_REQUEST = 'MARKPAID_PARTNER_INVOICE_REQUEST';
export const MARKPAID_PARTNER_INVOICE_SUCCESS = 'MARKPAID_PARTNER_INVOICE_SUCCESS';
export const MARKPAID_PARTNER_INVOICE_FAILURE = 'MARKPAID_PARTNER_INVOICE_FAILURE';